export const lightGrey = "#F0F0F0";
export const greenCyan = "#00b894";
export const darkPurple = "#7b4f80";

export const snowLegendColors = ["#eeeeee", "#8fcda7", "#ddf2b2", "#fee196", "#f6924e", "#d91d15"];
export const crimeDatasetsSweColorList = ["#ffffff", "#ffbfbf", "#ff8080", "#ff4040", "#ff0000"];
export const cocoColorRange = ["#f9f9f9", "#06C626", "#FFFA00", "#D91C15"];

export const gemSeismicColors = [
  "#ffffff",
  "#d7e3ee",
  "#b5caff",
  "#8fb3ff",
  "#7f97ff",
  "#abcf63",
  "#e8f59e",
  "#fffa14",
  "#ffd121",
  "#ffa30a",
  "#ff4c00",
];

// To obtain  such file save the QGIS color map, and then
// apply replacement ' ' ==> ,  \n ==> ],\n[ in extended search mode of Notepad++
const qgis_map_export_58 = [
  [1, 255, 255, 255, 0, 1],
  [2, 243, 251, 255, 255, 2],
  [3, 232, 246, 255, 255, 3],
  [4, 220, 242, 255, 255, 4],
  [5, 208, 237, 255, 255, 5],
  [6, 197, 233, 255, 255, 6],
  [7, 185, 228, 255, 255, 7],
  [8, 173, 224, 255, 255, 8],
  [9, 162, 219, 255, 255, 9],
  [10, 155, 218, 252, 255, 10],
  [11, 156, 220, 244, 255, 11],
  [12, 157, 222, 236, 255, 12],
  [13, 158, 224, 229, 255, 13],
  [14, 158, 226, 221, 255, 14],
  [15, 159, 228, 213, 255, 15],
  [16, 160, 230, 206, 255, 16],
  [17, 161, 232, 198, 255, 17],
  [18, 161, 234, 190, 255, 18],
  [19, 171, 236, 182, 255, 19],
  [20, 182, 239, 174, 255, 20],
  [21, 193, 241, 166, 255, 21],
  [22, 204, 244, 157, 255, 22],
  [23, 215, 246, 149, 255, 23],
  [24, 226, 249, 141, 255, 24],
  [25, 237, 251, 132, 255, 25],
  [26, 248, 253, 124, 255, 26],
  [27, 255, 252, 118, 255, 27],
  [28, 255, 244, 115, 255, 28],
  [29, 255, 236, 113, 255, 29],
  [30, 255, 228, 110, 255, 30],
  [31, 255, 220, 107, 255, 31],
  [32, 255, 211, 105, 255, 32],
  [33, 255, 203, 102, 255, 33],
  [34, 255, 195, 99, 255, 34],
  [35, 255, 187, 97, 255, 35],
  [36, 255, 179, 94, 255, 36],
  [37, 255, 171, 91, 255, 37],
  [38, 255, 163, 88, 255, 38],
  [39, 255, 155, 86, 255, 39],
  [40, 255, 147, 83, 255, 40],
  [41, 255, 139, 80, 255, 41],
  [42, 255, 131, 78, 255, 42],
  [43, 255, 122, 75, 255, 43],
  [44, 255, 114, 72, 255, 44],
  [45, 255, 106, 70, 255, 45],
  [46, 255, 98, 67, 255, 46],
  [47, 255, 90, 64, 255, 47],
  [48, 255, 82, 62, 255, 48],
  [49, 255, 74, 59, 255, 49],
  [50, 255, 66, 56, 255, 50],
  [51, 255, 58, 54, 255, 51],
  [52, 255, 50, 51, 255, 52],
  [53, 255, 41, 48, 255, 53],
  [54, 255, 33, 46, 255, 54],
  [55, 255, 25, 43, 255, 55],
  [56, 255, 17, 40, 255, 56],
  [57, 255, 9, 38, 255, 57],
  [58, 255, 1, 35, 255, 58],
];

const no_value_color = [0, 255, 255, 255, 255, 0];
// array must contain 59 colors, one color is reserved for "no-value".

export const qgis_map_export_58_colors = [no_value_color, ...qgis_map_export_58]
  .map((x) => `rgb(${x[1]},${x[2]},${x[3]})`)
  .reverse();

// To obtain  such file save the QGIS color map color_map_REALERISK_1342.clr, and then
// apply replacement ' ' ==> ,  \n ==> ],\n[ in extended search mode of Notepad++

const qgis_map_export_56 = [
  [1, 255, 255, 255, 255, 1],
  [2, 243, 250, 255, 255, 2],
  [3, 231, 246, 255, 255, 3],
  [4, 219, 241, 255, 255, 4],
  [5, 207, 236, 255, 255, 5],
  [6, 194, 232, 255, 255, 6],
  [7, 182, 227, 255, 255, 7],
  [8, 170, 223, 255, 255, 8],
  [9, 158, 218, 255, 255, 9],
  [10, 156, 218, 249, 255, 10],
  [11, 156, 220, 241, 255, 11],
  [12, 157, 222, 233, 255, 12],
  [13, 158, 225, 225, 255, 13],
  [14, 159, 227, 217, 255, 14],
  [15, 160, 229, 209, 255, 15],
  [16, 160, 231, 201, 255, 16],
  [17, 161, 233, 193, 255, 17],
  [18, 167, 235, 185, 255, 18],
  [19, 178, 238, 177, 255, 19],
  [20, 190, 240, 168, 255, 20],
  [21, 201, 243, 160, 255, 21],
  [22, 213, 245, 151, 255, 22],
  [23, 224, 248, 142, 255, 23],
  [24, 235, 251, 134, 255, 24],
  [25, 247, 253, 125, 255, 25],
  [26, 255, 253, 118, 255, 26],
  [27, 255, 244, 115, 255, 27],
  [28, 255, 236, 113, 255, 28],
  [29, 255, 228, 110, 255, 29],
  [30, 255, 219, 107, 255, 30],
  [31, 255, 211, 104, 255, 31],
  [32, 255, 202, 102, 255, 32],
  [33, 255, 194, 99, 255, 33],
  [34, 255, 186, 96, 255, 34],
  [35, 255, 177, 93, 255, 35],
  [36, 255, 169, 90, 255, 36],
  [37, 255, 160, 88, 255, 37],
  [38, 255, 152, 85, 255, 38],
  [39, 255, 144, 82, 255, 39],
  [40, 255, 135, 79, 255, 40],
  [41, 255, 127, 77, 255, 41],
  [42, 255, 118, 74, 255, 42],
  [43, 255, 110, 71, 255, 43],
  [44, 255, 102, 68, 255, 44],
  [45, 255, 93, 65, 255, 45],
  [46, 255, 85, 63, 255, 46],
  [47, 255, 77, 60, 255, 47],
  [48, 255, 68, 57, 255, 48],
  [49, 255, 60, 54, 255, 49],
  [50, 255, 51, 52, 255, 50],
  [51, 255, 43, 49, 255, 51],
  [52, 255, 35, 46, 255, 52],
  [53, 255, 26, 43, 255, 53],
  [54, 255, 18, 40, 255, 54],
  [55, 255, 9, 38, 255, 55],
  [56, 255, 1, 35, 255, 56],
];

export const qgis_map_export_56_colors = [no_value_color, ...qgis_map_export_56]
  .map((x) => `rgb(${x[1]},${x[2]},${x[3]})`)
  .reverse();

export const coastDistanceColors = [
  [-42.8571428571428541, 128, 191, 171, 255, "<= -43"],
  [-35.7142857142857153, 199, 232, 173, 255, "-43 — -36"],
  [-28.5714285714285694, 246, 243, 179, 255, "-36 — -29"],
  [-21.42857142857142705, 254, 201, 128, 255, "-29 — -21"],
  [-14.2857142857142847, 240, 123, 74, 255, "-21 — -14"],
  [-7.1428571428571388, 223, 64, 46, 255, "-14 — -7"],
  [0, 255, 0, 255, 255, "-7 — 0"],
  [Infinity, 43, 131, 186, 76, "> 0"],
];
// consider also opacity
export const coastDistanceColorsList = coastDistanceColors.map(
  (x) => `rgba(${x[1]},${x[2]},${x[3]},${typeof x[4] === "number" ? x[4] / 255 : 1})`,
);

export const nasaPrecipitationColors = [
  "#f9f9f9",
  "#2a5eec",
  "#64abb0",
  "#9dd3a6",
  "#c7e8ad",
  "#ecf7b9",
  "#ffedaa",
  "#fec980",
  "#f99d59",
  "#e85b3b",
  "#d7191c",
  "#780307",
  "#360103",
];

export const nasaLandslideColors = [
  "#dddddd",
  "#f9f9f9",
  "#64abb0",
  "#9dd3a6",
  "#c7e8ad",
  "#ecf7b9",
  "#ffedaa",
  "#fec980",
  "#f99d59",
  "#e85b3b",
  "#d7191c",
  "#780307",
  "#360103",
];

export const nasaPrecipitationColourMapping = [
  [1, nasaPrecipitationColors[0], "<0.1 mm"],
  [2, nasaPrecipitationColors[1], "0.1 - 0.2 mm"],
  [5, nasaPrecipitationColors[2], "0.3 - 0.5 mm"],
  [10, nasaPrecipitationColors[3], "0.6 - 1 mm"],
  [20, nasaPrecipitationColors[4], "1.1 - 2 mm"],
  [50, nasaPrecipitationColors[5], "2.1 - 5 mm"],
  [100, nasaPrecipitationColors[6], "5.1 - 10 mm"],
  [200, nasaPrecipitationColors[7], "10.1 - 20 mm"],
  [500, nasaPrecipitationColors[8], "20.1 - 50 mm"],
  [1000, nasaPrecipitationColors[9], "50.1 - 100 mm"],
  [2000, nasaPrecipitationColors[10], "100.1 - 200 mm"],
  [5000, nasaPrecipitationColors[11], ">200.1 mm"],
];

export const nasaLandslideColourMapping = [
  [0, nasaLandslideColors[0], "No data"],
  [100, nasaLandslideColors[1], "< 0.1"],
  [200, nasaLandslideColors[2], "0.1 - 0.2"],
  [300, nasaLandslideColors[3], "0.2 - 0.3"],
  [400, nasaLandslideColors[4], "0.3 - 0.4"],
  [500, nasaLandslideColors[5], "0.4 - 0.5"],
  [600, nasaLandslideColors[6], "0.5 - 0.6"],
  [700, nasaLandslideColors[7], "0.6 - 0.7"],
  [800, nasaLandslideColors[8], "0.7 - 0.8"],
  [900, nasaLandslideColors[9], "0.8 - 0.9"],
  [1000, nasaLandslideColors[10], "0.9 - 1.0"],
];
